export default {
  placeholder: {
    subject: 'Message title (for LMS and MMS, up to 30 characters)',
    smsContent: 'If it exceeds 45 characters, it is converted to LMS.',
    lmsContent: 'LMS messages can be entered up to 1000 characters.',
    mmsContent: 'MMS messages can be entered up to 1000 characters.',
    smsLength: '45 characters',
    lmsLength: '1000 characters',
    mmsLength: '1000 characters',
  },
  comment: {
    image: '※ Automatically converted to MMS.',
  },
};
